export default {
  description: 'Los modelos eliminados permanecen aquí 7 días. Después se eliminan definitivamente.',
  search: 'Buscar',
  empty: 'No hay modelos eliminados',
  headerName: 'Nombre',
  headerType: 'Tipo',
  headerDeletedBy: 'Eliminado por',
  headerDeleted: 'Eliminado',
  headerDaysLeft: 'Se elimina en',
  headerSource: 'Eliminado desde',
  daysLeft: '{count} días',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Ref.',
  typeEkrm: 'EKRM',
  source: {
    modelManager: 'Model Manager',
    automaticModels: 'Modelos DIY',
    adHocModels: 'Modelos Ad-Hoc',
    modelComposer: 'Model Composer',
    manageEkrm: 'Manage EKRM'
  },
  restore: 'Restaurar',
  restoreTitle: '¿Restaurar modelo?',
  restoreMessage: '{name} volverá a estar disponible, con sus planes y los accesos que tenía.',
  restoreMessageEkrm: '{name} volverá a estar disponible en Manage EKRM.',
  nameConflict: 'Otro modelo usa ahora este nombre. Elige uno distinto para restaurarlo.',
  newNameLabel: 'Nombre',
  restoredName: '{name} (restaurado)',
  cancel: 'Cancelar',
  close: 'Cerrar',
  restored: '{name} fue restaurado.',
  reportPending: 'Su reporte de modelo se está generando.',
  warning: {
    'version-unlinked': 'Su lugar en la familia de versiones fue ocupado, así que se restauró como un modelo independiente.',
    'request-exists': 'Su solicitud DIY ya existía y se dejó como estaba.',
    'ekrm-missing': 'Su EKRM ya no existe, así que no aparecerá en Model Composer.'
  },
  error: {
    'target-exists': 'Otro modelo usa ahora el mismo ID, así que este no se puede restaurar.',
    'storage-changed': 'Los archivos del modelo fueron reemplazados por un modelo más nuevo, así que este no se puede restaurar.',
    'trash-entry-not-found': 'Este modelo ya no está en la papelera.',
    'permission-denied': 'No tienes permiso para restaurar este modelo.',
    unknown: 'Error al restaurar el modelo'
  }
}
